<template>
  <v-container>
    <LoginTopbar />

    <v-row class="expiredLink-content">
      <v-col>
        <v-row class="mb-2">
          <v-col class="d-flex justify-center">
            <div class="pa-8 bg-grey-100 rounded-circle" style="line-height: normal;">
              <app-material-icon name="close" size="xxl" color="inherit" />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h1 class="text-center mb-4">
              {{ $t('Error.views.expiredLink.expiredAt', { date: ISOToDDMMYYYY(expirationDate), hour: expirationHour }) }}
            </h1>
            <div class="text-center">{{ $t('Error.views.expiredLink.newLinkResent') }}</div>
            <div class="text-center">{{ $t('Error.views.expiredLink.pleaseCheck') }}</div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { ISOToDDMMYYYY } from '@/common/utils/dates'
  import LoginTopbar from '@/login/LoginTopbar.vue'

  export default {
    name: 'ExpiredLink',
    components: { LoginTopbar },
    props: {
      expirationDate: {
        type: String,
        required: true,
      },
      expirationHour: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        ISOToDDMMYYYY,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .expiredLink-content {
    margin-top: 10%;
  }

  @media screen and (max-width: 768px) {
    .expiredLink-content {
      margin-top: 5%;
    }
  }
</style>
